import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlfaNumeric]'
})
export class AlfaNumericDirective {

  constructor(@Optional() private formControl: NgControl) { }
  @HostListener('input', ['$event']) onInput(event: any) {
    if (this.formControl) {
      this.formControl.control!.patchValue(this.formControl.control!.value.replaceAll(/[^a-zA-Z0-9 ]/gi, ''));
    }
  }
}
